import * as React from 'react';

import AlarmClock16 from './AlarmClock16';

export const alarmClock16 = () => <AlarmClock16 />;

export default {
    title: 'Icon|Line|AlarmClock16',
    component: AlarmClock16,
    parameters: {
        notes: "`import AlarmClock16 from 'box-ui-elements/es/icon/line/AlarmClock16';`",
    },
};
